module.exports = __webpack_public_path__ + "d2d5ec2744217ba0f3879dea8b08d5c3.woff";